// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "css/" + {"96":"oauth-login","897":"oauth-consent"}[chunkId] + "." + {"96":"8c8f0534","897":"5fa95825"}[chunkId] + ".css"; };